import { BRANDING_STATUS } from "stores/useBrandingStore";

const TERMINAL_BRANDING_STATUSES = new Set([
  BRANDING_STATUS.READY,
  BRANDING_STATUS.ERROR,
]);

/**
 * Routes wait for the branding request owned by their auth state. Error is a
 * terminal state because the resolver can then render cache/env/defaults once.
 */
export function shouldWaitForBranding(
  authBootstrapStatus,
  preLoginBrandingStatus,
  postLoginBrandingStatus
) {
  if (authBootstrapStatus === "unauthenticated") {
    return !TERMINAL_BRANDING_STATUSES.has(preLoginBrandingStatus);
  }

  if (authBootstrapStatus === "authenticated") {
    return !TERMINAL_BRANDING_STATUSES.has(postLoginBrandingStatus);
  }

  return false;
}
